import AboutSection from './AboutSection'
import ProjectsSection from './ProjectsSection'
import ContactSection from './ContactSection'
import ArticlesSection from './ArticlesSection'

export default {
  AboutSection,
  ProjectsSection,
  ContactSection,
  ArticlesSection
}



// WEBPACK FOOTER //
// ./src/components/Sections/index.js